__turbopack_context__.v({
  "link": "ngv6sa_link",
  "text": "ngv6sa_text",
});
